/** Custom-page type catalog — the vendor tokens (`block | 5xx | rateLimit | js |
 *  captcha | maint`) with human labels. Shared by the list and the form dialog. */
export const CUSTOM_PAGE_TYPES: { value: string; label: string }[] = [
  { value: 'block', label: 'Block (403)' },
  { value: '5xx', label: '500-class error' },
  { value: 'rateLimit', label: 'Rate limit' },
  { value: 'js', label: 'JS challenge' },
  { value: 'captcha', label: 'Captcha' },
  { value: 'maint', label: 'Maintenance' },
];

const LABELS = new Map(CUSTOM_PAGE_TYPES.map((t) => [t.value, t.label]));

/** Friendly label for a custom-page type token (falls back to the raw token). */
export const customPageTypeLabel = (t?: string) => (t ? LABELS.get(t) ?? t : '—');

/** Types that require a `token` (the `::JS_BOX::` / `::CAPTCHA_BOX::` placeholder). */
export const TOKEN_TYPES = new Set(['js', 'captcha']);

/** Fixed placeholder token per type — not user-editable. */
export const TOKEN_VALUES: Record<string, string> = {
  js: '::JS_BOX::',
  captcha: '::CAPTCHA_BOX::',
};
